export default __webpack_public_path__ + "static/media/volenteer1.758a4659.png";